import { ResourceCard } from './resource-card';
import type { CardProps } from './types';

/** PDF block tile — its uploaded banner, else the resource icon. */
export const DocumentCard = ({ block, onClick }: CardProps) => (
  <ResourceCard
    block={block}
    onClick={onClick}
    caption={block.pdfFilename || block.title || 'Document'}
    bannerUrl={block.pdfBannerUrl}
  />
);
